module.exports = {"350721001":"双溪街道","350721100":"建西镇","350721101":"洋口镇","350721102":"元坑镇","350721103":"埔上镇","350721104":"大历镇","350721105":"大干镇","350721106":"仁寿镇","350721107":"郑坊镇","350721200":"洋墩乡","350721202":"岚下乡","350721203":"高阳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350721.json
// module id = 1334
// module chunks = 0